import React, { useEffect, useState } from 'react'
import MenuDesktop from './components/MenuDesktop'
import MenuMobile from './components/MenuMobile'
import { IHeaderContent, DEVICES_EUM } from '../models'

function Menu({ content }: { content: IHeaderContent }) {
  const [device, setDevice] = useState<DEVICES_EUM | null>(null)

  const checkDevice = () => {
    const screenSize = window.innerWidth
    if (screenSize < 1440) {
      setDevice(DEVICES_EUM.MOBILE)
    } else {
      setDevice(DEVICES_EUM.DESKTOP)
    }
  }
  useEffect(() => {
    window.scroll()
    checkDevice()
    window.addEventListener('resize', checkDevice)
    return () => window.removeEventListener('resize', checkDevice)
  }, [])

  return (
    <nav>
      {content?.headerContent && (
        <>
          {device === DEVICES_EUM.DESKTOP && (
            <MenuDesktop
              menuItems={content?.headerContent.MenuItems}
              languageItems={content?.languageItems}
              searchContent={content?.search}
            />
          )}
          {device === DEVICES_EUM.MOBILE && (
            <MenuMobile
              menuItems={content?.headerContent.MenuItems}
              languageItems={content?.languageItems}
              searchContent={content?.search}
            />
          )}
        </>
      )}
    </nav>
  )
}

export default Menu
